import { Grid, Stack, Typography } from '@mui/material';

/**
 * Settings card row: label + description on the left, control right-aligned.
 * Used across the Hostess Auto Reply pages.
 */
const SettingRow = (props: {
    title: string;
    description: string;
    control: React.ReactNode;
    /** Wide controls drop below the text on phones (right-aligned) instead of squeezing the text into a sliver. */
    wide?: boolean;
    last?: boolean;
}) => {
    const { title, description, control, wide, last } = props;

    return (
        <Grid container spacing={1} flexGrow={0} alignItems="center" sx={{ mb: last ? 0 : 2 }}>
            <Grid item xs={wide ? 12 : true} sm>
                <Typography variant="body1">{title}</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {description}
                </Typography>
            </Grid>
            <Grid item xs={wide ? 12 : 'auto'} sm="auto">
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" sx={{ width: '100%' }}>
                    {control}
                </Stack>
            </Grid>
        </Grid>
    );
};

export default SettingRow;
